import { useEffect, useState } from "react";
import { API } from "../../../lib/api";
import { Alert, Box, CircularProgress } from "@mui/material";
import RevenueLine from "../../../components/Reports/RevenueLine";
import RevenueLineBookedStageTrendCard from "../../../components/RevenueLineBookedStageTrendCard";

const ForecastCharts = ({ allLines }) => {
    const [loading, setLoading] = useState(true);
    const [years, setYears] = useState([]);
    const [revenueLineData, setRevenueLineData] = useState([]);
    const [error, setError] = useState(false);
    const permission = ["manager", "admin"].includes(localStorage.getItem("role"));

    useEffect(() => {
        let active = true;
        async function fetchRevenueTrend() {
            try {
                // This endpoint also supplies the retained annual revenue trend.
                const response = await API.Reporting.ForecastGraphWeighted();
                if (!active) return;
                if (response.status !== 200 || !response.data) throw new Error('Unable to load revenue trend');
                const years = Object.keys(response.data).sort((a, b) => Number(a) - Number(b));
                setYears(years);
                setRevenueLineData(years.map(year => Math.round(Number(response.data[year]?.["Revenue Taken"]?.totalAmount) || 0)));
            } catch {
                if (active) setError(true);
            } finally {
                if (active) setLoading(false);
            }
        }
        if (permission) fetchRevenueTrend();
        else setLoading(false);
        return () => { active = false; };
    }, [permission]);

    return <div className="container-fluid">
        <div style={{ display: "flex", flexWrap: "wrap", justifyContent: "space-evenly" }}>
            <RevenueLineBookedStageTrendCard lines={allLines} />
            {permission && (loading ? <Box sx={{ p: 3 }}><CircularProgress /></Box>
                : error ? <Alert severity="error">Unable to load the revenue trend. Please reload to try again.</Alert>
                : <RevenueLine category={years} lineData={revenueLineData} />)}
        </div>
    </div>;
};

export default ForecastCharts;
